import React, { useContext, useEffect, useState } from "react";
import { View } from "react-native";
import { Client, ConstructionLot, ConstructionSite, Destination, ErgoTask, HeaderWarehouse, ObjectInfo, Supplier } from '../../../types'
import useApi from '../../../apis/useApi'
import { Button, ImValidators, Input, InputDateTime, Label, LanguageContext, Note } from "@infominds/react-native-components";
import ErrorMessage from "../../../components/ErrorMessage";
import NewDocumentStorage from "../../../utils/NewDocumentStorage";
import SelectionBox from "../../../cards/SelectionBox";
import Selection from "../../../cards/Selection";

export default function NewHeaderWarehouse(props: { constructionSite?: ObjectInfo, companyId?: number, task: ErgoTask, onSave: any, onSavedDocumentChanged: any, savedDocumentId: string, savedHeader: any }) {
    const lang = useContext(LanguageContext);

    const [errorMessage, setErrorMessage] = useState<string>();

    const [selectedConstructionSite] = useState(props.constructionSite);

    const [date, setDate] = useState<Date | undefined>((props.savedHeader && new Date(props.savedHeader.date)) || undefined);
    const [note, setNote] = useState<string>((props.savedHeader && props.savedHeader.note) || '');
    const [docNrSupplier, setDocNrSupplier] = useState<string>((props.savedHeader && props.savedHeader.docNrSupplier) || '');

    const [client, setClient] = useState<Client | undefined>(undefined);

    const [objectLots, setObjectLots] = useState<ConstructionLot[]>([]);
    const [objectLot, setObjectLot] = useState<ConstructionLot | undefined>((props.savedHeader && props.savedHeader.objectLot) || undefined);

    const [suppliers, setSuppliers] = useState<Supplier[]>();
    const [supplier, setSupplier] = useState<Supplier | undefined>((props.savedHeader && props.savedHeader.supplier) || undefined);

    const [destinations, setDestinations] = useState<Destination[]>([]);
    const [destination, setDestination] = useState<Destination | undefined>((props.savedHeader && props.savedHeader.destination) || undefined);

    useEffect(() => {

        useApi.getCompany(props.constructionSite ? props.constructionSite?.company?.company_id : props.companyId).then((res: Client) => {
            if (res) setClient(res)
        })

        useApi.getSuppliers().then((res: Supplier[]) => { setSuppliers(res) })

        if (props.constructionSite?.object_id) {
            useApi.getOpenObjectLots(props.constructionSite?.object_id).then((res: ConstructionLot[]) => { setObjectLots(res) });
            // useApi.getDestinations(props.constructionSite?.company?.company_id).then((res: Destination[]) => { setDestinations(res) });
        }
    }, [])

    useEffect(() => {
        if (supplier !== undefined) {
            useApi.getDestinations(supplier?.id).then((res: Destination[]) => { setDestinations(res) });
        }
    }, [supplier])

    //save on every change
    useEffect(() => {
        const newDoc = {
            date: props.savedDocumentId,
            docType: Number(props.task.param_list.DOCTYPE),
            header: {
                supplier: supplier,
                selectedConstructionSite: selectedConstructionSite,
                objectLot: objectLot,
                destination: destination,
                date: date,
                docNrSupplier: docNrSupplier,
                note: note,
                companyIdForCount: client?.id
            }
        }
        NewDocumentStorage.save(props.constructionSite?.object_id || client?.id, props.task?.task_id, newDoc)
        props.onSavedDocumentChanged(newDoc)
    }, [supplier, selectedConstructionSite, objectLot, destination, date, docNrSupplier, note])

    function save() {
        if (client && (props.companyId === undefined ? selectedConstructionSite : true) && date && supplier) {  // objectLot
            var data: HeaderWarehouse = {
                client: supplier,
                // supplier: supplier,
                object: selectedConstructionSite,
                objectLot: objectLot,
                destination: destination,
                docDateSupplier: date,
                docNrSupplier: docNrSupplier,
                note: note
            }
            props.onSave(data)
            setErrorMessage(undefined)
        } else {
            setErrorMessage(lang.REQUIRED_FIELDS);
        }
    }

    return (
        <View>
            {selectedConstructionSite &&
                <SelectionBox title={lang.CANTIERE}>
                    <Selection
                        title={lang.CANTIERE}
                        icon={'hardHat'}
                        selected={selectedConstructionSite}
                        itemTitle={(item: ConstructionSite) => item.description}
                        searchString={(item: ConstructionSite) => item.description}
                    // value={constructionSites}
                    //onChange={(item: ConstructionSite) => setSelectedConstructionSite(item)}
                    />
                    <Selection
                        title={lang.LOTTO}
                        icon={'pencilRuler'}
                        selected={objectLot}
                        hidden={objectLots?.length === 0}
                        value={objectLots}
                        itemTitle={(item: ConstructionLot) => item.description}
                        searchString={(item: ConstructionLot) => item.description}
                        onChange={(item: ConstructionLot) => setObjectLot(item)}
                    />
                </SelectionBox>
            }

            <SelectionBox title={lang.TRANSPORT_DATA}>
                <Selection
                    title={lang.SUPPLIER}
                    icon={'truck'}
                    selected={supplier}
                    value={suppliers}
                    required
                    showError={!!errorMessage && !supplier}
                    itemTitle={(item: Supplier) => item.description}
                    searchString={(item: Supplier) => item.description}
                    onChange={(item: Supplier) => setSupplier(item)}
                />

                <Selection
                    title={lang.DESTINATIONS}
                    disabled={supplier === undefined}
                    hidden={(props.constructionSite && props.constructionSite.destination_id === undefined) || supplier === undefined || destinations.length === 0}
                    // hidden={destinations.length === 0}
                    icon={'mapMarker'}
                    selected={destination}
                    value={destinations}
                    itemTitle={(item: Destination) => item.description}
                    searchString={(item: Destination) => item.description}
                    onChange={(item: Destination) => setDestination(item)}
                />
            </SelectionBox>


            <View>
                <Label text={lang.DOC_DATE_SUPPLIER} required />
                <InputDateTime
                    value={date}
                    onDelete={() => setDate(undefined)}
                    onConfirm={setDate}
                    text={''}
                    style={ImValidators.requiredInput(date, !!errorMessage)}
                    mode='date' />
            </View>

            <View>
                <Label text={lang.DOC_NR_SUPPLIER} />
                <Input value={docNrSupplier} onChangeText={(text: string) => setDocNrSupplier(text)} />
            </View>

            <View>
                <Label text={lang.NOTE} />
                <Note value={note} onChangeText={(text: string) => setNote(text)} />
            </View>

            <ErrorMessage errorMessage={errorMessage} />

            {/* TODO make button flex 1 at bottom of page like on the add material page after this page */}
            <Button style={{ marginTop: 20 }} title={lang.NEXT} onPress={() => { save() }} />

        </View>
    )
}